<template>
  <div>
    <v-select
      v-model="selectedCategory"
      :items="categories"
      item-text="name"
      item-value="id"
      return-object
      label="Produkt-Kategorie"
      outlined
      dense
      :loading="loading || isLoadingCategories"
      :disabled="disabled"
      prepend-inner-icon="inventory_2"
      placeholder="Bitte wählen Sie eine Kategorie"
      @change="onCategoryChange"
      hide-details
    >
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
      </template>
    </v-select>
  </div>
</template>

<script>
import WarehouseService from '@/services/WarehouseService';

export default {
  name: "CategorySelect",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Object, Number],
      default: null
    }
  },
  data: () => ({
    selectedCategory: null,
    categories: [],
    isLoadingCategories: false
  }),
  async created() {
    await this.loadCategories();
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.selectedCategory = newVal;
      }
    }
  },
  methods: {
    async loadCategories() {
      this.isLoadingCategories = true;
      try {
        const response = await WarehouseService.getCategories();
        this.categories = response.data || [];
      } catch (error) {
        console.error('Fehler beim Laden der Kategorien:', error);
      } finally {
        this.isLoadingCategories = false;
      }
    },
    
    onCategoryChange() {
      this.$emit('input', this.selectedCategory);
      this.$emit('category-selected', this.selectedCategory);
    }
  }
};
</script>

<style scoped>
/* Clean select styling */
</style>

